
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import infoGetActions from '../../sagas/info';
import { getToken } from '../../reducers/auth';
import { getProjectKatuzeItems } from '../../reducers/project';

import IsknParList from '../common/iskn/IsknParList';

const IsknObjectListPar = ({data, isknDate, loading}) => {

    const dispatch = useDispatch();
    const infoActions = infoGetActions(dispatch);
    const token = useSelector(state => getToken(state.auth));
    const projectKatuzeItems = useSelector(state => getProjectKatuzeItems(state.project));

    const handleParClick = (parId) => {
        infoActions.getObjectParcela(
            token,
            projectKatuzeItems.map(item => item.kod),
            isknDate,
            parId
        );
    }

    return (
        <IsknParList
            data={data}
            isknDate={isknDate}
            loading={loading}
            onClick={handleParClick}
        />
    );
}

export default IsknObjectListPar;
